import { RootState } from '../index';

const getSelectedLocationId = (state: RootState) => state.inventoryReducer.selectedLocationId;
const getProductTypes = (state: RootState) => state.inventoryReducer.productTypes;
const getTags = (state: RootState) => state.inventoryReducer.tags;
const getVendors = (state: RootState) => state.inventoryReducer.vendors;
const getLocationInventory = (state: RootState) => state.inventoryReducer.inventoryItems;
const getCurrentWorker = (state: RootState) => state.inventoryReducer.currentWorker;
const getCategories = (state:RootState) => state.inventoryReducer.categories;
const getSelectedVariant = (state: RootState) => state.inventoryReducer.selectedVariant;
const getIsTransferWindowOpen = (state: RootState) => state.inventoryReducer.isTransferWindowOpen;

export {
  getSelectedLocationId,
  getProductTypes,
  getTags,
  getVendors,
  getLocationInventory as getInventory,
  getCurrentWorker,
  getCategories,
  getSelectedVariant,
  getIsTransferWindowOpen,
};
